import { animated } from '@react-spring/web';
import styled from 'styled-components';
import { variant } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { ProgressBarProps } from '../ProgressBar';

interface BarProps {
    variant: ProgressBarProps['variant'];
}

export const Bar = styled(animated.div)<BarProps>`
    height: 100%;
    border-radius: 2px;
    min-width: 4px;

    ${variant({
        prop: 'variant',
        variants: {
            neutral: {
                backgroundColor: theme.colors.foreground.default,
            },
            accent: {
                backgroundColor: theme.colors.accent.emphasis,
            },
            attention: {
                backgroundColor: theme.colors.attention.emphasis,
            },
            negative: {
                backgroundColor: theme.colors.negative.emphasis,
            },
        },
    })}
`;
